import React from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  ThemeProvider,
  CssBaseline,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SEOHelmet from "../customComponent/SEOHelmet";
import constant from "../../constants/Constatnt";
import theme from "../../theme/theme";
import { appTheme } from "../../theme/colorTheme";

const TopMobileBettingAppsBlog = () => {
  const pageTitle =
    "Top Mobile Betting Apps for Football Fans | " + constant.seoWebsiteName;
  const pageDescription =
    "Discover the best mobile betting apps for football enthusiasts. Get secure, fast, and exciting live betting experiences with top football betting platforms available on mobile devices.";
  const pageKeywords =
    "Mobile Betting Apps, Football Betting App, Online Football Betting, Football Betting India, Mobile Sports Betting, Best Football Betting Apps, Live Football Betting, Secure Betting Apps, " +
    constant.seoWebsiteName +
    " Football Betting";

  const handleBack = () => {
    if (document.referrer) {
      // If a referrer exists, go there
      window.location.href = document.referrer;
    } else {
      // Fallback: go to homepage or blogs list
      window.location.href = "/";
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container
        maxWidth="md"
        sx={{
          py: 4,
          bgcolor: appTheme.color11,
          color: appTheme.color1,
          borderRadius: 3,
          boxShadow: `0 2px 16px ${appTheme.color12}33`,
        }}
      >
        {/* SEO Meta Tags */}
        <SEOHelmet
          title={pageTitle}
          description={pageDescription}
          keywords={pageKeywords}
        />

        {/* Back Button */}
        <Button
          startIcon={<ArrowBackIcon />}
          variant="contained"
          sx={{
            mb: 3,
            bgcolor: appTheme.color12,
            color: appTheme.color0,
            "&:hover": {
              bgcolor: appTheme.color14,
              color: appTheme.color1,
            },
          }}
          onClick={handleBack}
        >
          Back
        </Button>

        {/* Blog Content */}
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{ color: appTheme.color14 }}
        >
          Top Mobile Betting Apps for Football Fans
        </Typography>

        <Typography variant="body1" paragraph>
          In the fast-paced world of football, betting enthusiasts increasingly rely on mobile betting apps
          to place their wagers anytime, anywhere. With advancements in technology, football betting has
          never been more accessible or convenient. Leading mobile apps offer real-time odds, live streaming,
          and secure payments to make your betting experience seamless and exciting.
        </Typography>

        <Typography variant="h4" component="h2" gutterBottom sx={{ color: appTheme.color12 }}>
          Why Choose Mobile Football Betting Apps?
        </Typography>
        <Typography variant="body1" paragraph>
          Mobile football betting apps provide unmatched flexibility and convenience for bettors. Whether
          you’re at home, commuting, or at the game, you can easily access live odds, place bets instantly,
          and manage your account with just a few taps. These apps often include features like in-play betting,
          cash-out options, and personalized notifications for your favorite football leagues.
        </Typography>

        <Typography variant="h4" component="h2" gutterBottom sx={{ color: appTheme.color12 }}>
          Features to Look for in the Best Football Betting Apps
        </Typography>
        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
          <Typography component="li">Wide range of football markets including domestic and international leagues</Typography>
          <Typography component="li">Real-time live betting with up-to-date odds</Typography>
          <Typography component="li">User-friendly interface with quick bet placement</Typography>
          <Typography component="li">Secure and rapid payment methods supporting deposits and withdrawals</Typography>
          <Typography component="li">Customer support available 24/7 via chat, phone, or email</Typography>
          <Typography component="li">Bonuses, promotions, and rewards programs tailored for football fans</Typography>
        </Box>

        <Typography variant="h4" component="h2" gutterBottom sx={{ color: appTheme.color12 }}>
          Top Mobile Football Betting Apps You Should Try
        </Typography>
        <Typography variant="body1" paragraph>
          Here are some of the top mobile football betting apps available to Indian players that offer
          excellent betting options, reliability, and security:
        </Typography>
        <Box component="ol" sx={{ pl: 4, mb: 2 }}>
          <Typography component="li"><strong>WorldBaazi:</strong> Highly rated for cricket and football betting...</Typography>
          <Typography component="li"><strong>Betway:</strong> Popular internationally...</Typography>
          <Typography component="li"><strong>10CRIC:</strong> Tailored for Indian bettors...</Typography>
          <Typography component="li"><strong>LeoVegas:</strong> Known for a fantastic mobile interface...</Typography>
          <Typography component="li"><strong>Bet365:</strong> An industry leader...</Typography>
        </Box>

        <Typography variant="h4" component="h2" gutterBottom sx={{ color: appTheme.color12 }}>
          Tips for Responsible Football Betting on Mobile
        </Typography>
        <Typography variant="body1" paragraph>
          While mobile betting is exciting, it’s essential to bet responsibly...
        </Typography>

        <Typography variant="body1" paragraph>
          <em>
            Start your football betting journey today with the best mobile apps and experience the thrill
            of live football betting at your fingertips.
          </em>
        </Typography>
      </Container>
    </ThemeProvider>
  );
};

export default TopMobileBettingAppsBlog;
